<div class="notification-bell-dropdown" role="menu">
  <button type="button" role="menuitem" class="notif-item" (click)="onCommunicationClick()">
    <span class="notif-item-icon">
      <lucide-icon name="message-square" [size]="24"></lucide-icon>
    </span>
    <span class="notif-item-body">
      <span class="notif-item-title">{{ 'layout.header.notificationDropdown.communicationTeams' | translate }}</span>
      <span class="notif-item-description">{{ 'layout.header.notificationDropdown.communicationTeamsDescription' | translate }}</span>
    </span>
    @if (communicationCount > 0) {
      <span class="notif-item-count">{{ communicationCount >= 100 ? '99+' : communicationCount }}</span>
    }
    <lucide-icon class="notif-item-chevron" name="chevron-right" [size]="16"></lucide-icon>
  </button>

  @if (itemCount < 2) {
    <div class="notif-footer">
      {{ 'layout.header.notificationDropdown.footerNewCategories' | translate }}
    </div>
  }
</div>
